import { Component } from '@angular/core';
import { AppLayout } from '../layout/app-layout/app-layout';

@Component({
  selector: 'app-root',
  imports: [AppLayout],
  template: `<o3-core-app-layout></o3-core-app-layout>`,
})
export class App {}
